import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

export interface QuickAccessItem {
  to: string;
  icon: ReactNode;
  /** The icon tile's tint, a static class string. */
  tile: string;
  title: string;
  hint: string;
}

/** Where to start the day: one row per workspace, icon tile, title, hint and chevron. */
export function QuickAccessCard({ items }: { items: QuickAccessItem[] }) {
  return (
    <section className="surface-plane p-5">
      <h2 className="type-zonehead">Quick access</h2>
      <ul className="mt-3">
        {items.map((item, i) => (
          <li key={item.to} className={cn(i > 0 && "border-t border-slate-900/[0.05]")}>
            <Link
              to={item.to}
              className="group flex h-[60px] items-center gap-3 rounded-[10px] px-3 transition-colors duration-150 hover:bg-indigo-500/[0.04]"
            >
              <span className={cn("flex h-9 w-9 shrink-0 items-center justify-center rounded-lg", item.tile)}>
                {item.icon}
              </span>
              <span className="min-w-0 flex-1">
                <span className="block text-sm font-medium text-slate-900">{item.title}</span>
                <span className="block truncate text-[12.5px] text-slate-500">{item.hint}</span>
              </span>
              <ChevronRight className="h-4 w-4 shrink-0 text-slate-300 transition-transform group-hover:translate-x-0.5 group-hover:text-slate-500" />
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
